import Vue from 'vue'

// axios 相关配置
export const Axios = {
  baseURL: 'https://www.hejiatoupiao.com',
  imgURL: 'https://www.hejiatoupiao.com',
  apiPath: '/api',
  timeout: 25000,
  withCredentials: true,
  delay: 0
}

// token 授权
export const authorization = token => 'Bearer ' + token

// 授权 token
export const token = authorization => authorization.substr(7)

// 页面标题配置
export const Title = {
  make(title, params) {
    Object.keys(params).forEach(name => {
      title = title.replace(':' + name, params[name])
    })
    return '合家投票-' + title
  }
}

// 验证规则
export const Rules = {
  phone: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式错误', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入用户密码', trigger: 'blur' },
    { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' },
  ],
  code: [
    { required: true, message: '验证码不能为空', trigger: 'blur' },
    { pattern: /^\d{6}$/, message: '验证码为 6 个数字', trigger: 'blur' },
  ],
  group: [
    { required: true, message: '请输入分组名称', trigger: 'blur' },
    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
  ],
  video: [
    { required: true, message: '请插入视频通用代码', trigger: 'blur' },
    { pattern: /^<iframe.*?(>|<\/iframe>)$/i, message: '视频代码格式错误', trigger: 'blur' },
  ],
  url: [
    { required: true, message: '请输入链接地址', trigger: 'blur' },
    { pattern: /^https?:\/\/.+$/, message: '链接地址格式错误', trigger: 'blur' },
  ]
}

// 地址补全
export const Url = url => {
  if (url?.startsWith('http://') || url?.startsWith('https://')) {
    return url
  }
  return (Axios.baseURL || window.location.origin) + url
}

// 背景图片地址补全
export const BackgroundImage = url => 'url(' + Url(url) + ')'

// 背景图片地址补全
export const Api = url => Axios.baseURL + Axios.apiPath + url

Vue.prototype.$url = Url
Vue.prototype.$backgroundImage = BackgroundImage
Vue.prototype.$api = Api
